import Add from "@mui/icons-material/Add";
import Remove from "@mui/icons-material/Remove";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axiosInstance from "../../axios.js";
import { AuthContext } from "../../context/AuthContext";
import "./rightbar.css";

function Rightbar({ user }) {
  const PF = process.env.REACT_APP_PUBLIC_FOLDER;
  const [friends, setFriends] = useState([]);
  const { user: currentUser, dispatch } = useContext(AuthContext);
  const [followed, setFollowed] = useState(
    currentUser?.followings?.includes(user?.id)
  );

  useEffect(() => {
    const getFriends = async () => {
      if (!user?.id) return; // Don't fetch if user is not defined

      try {
        const friendList = await axiosInstance.get(
          "/api/users/friends/" + user.id
        );
        setFriends(friendList.data);
      } catch (err) {
        console.log("Error: ", err.message);
      }
    };
    getFriends();
  }, [user]);

  const handleClick = async () => {
    if (!user?.id || !currentUser?.id) {
      console.log("User not logged in");
      return; // Don't proceed if either user is not loaded
    }

    try {
      if (followed) {
        // No need to send userId - backend gets it from JWT token
        await axiosInstance.put(`/api/users/${user.id}/unfollow`);
        dispatch({ type: "UNFOLLOW", payload: user.id });
      } else {
        // No need to send userId - backend gets it from JWT token
        await axiosInstance.put(`/api/users/${user.id}/follow`);
        dispatch({ type: "FOLLOW", payload: user.id });
      }
      setFollowed(!followed);
    } catch (err) {
      console.error("Error following/unfollowing user:", err);
    }
  };

  const HomeRightbar = () => {
    return (
      <>
        <div className="birthdayContainer">
          <img
            className="birthdayImg"
            src={PF + "/birthday.png"}
            alt="birthday"
          />
          <span className="birthdayText">
            <b>Jhon</b> and <b>3 other friends</b> have a birthday today !
          </span>
        </div>
      </>
    );
  };

  const ProfileRightbar = () => {
    return (
      <>
        {user?.username !== currentUser?.username && (
          <button className="rightbarFollowButton" onClick={handleClick}>
            {followed ? "Unfollow" : "Follow"}
            {followed ? <Remove /> : <Add />}
          </button>
        )}
        <h3 className="rightbarTitle">User Information</h3>
        <div className="rightbarInfo">
          <div className="rightbarInfoItem">
            <span className="rightbarInfoKey">City : </span>
            <span className="rightbarInfoValue">
              {user.city ? user.city : "-"}
            </span>
          </div>
          <div className="rightbarInfoItem">
            <span className="rightbarInfoKey">State : </span>
            <span className="rightbarInfoValue">
              {user.from ? user.from : "-"}
            </span>
          </div>
          <div className="rightbarInfoItem">
            <span className="rightbarInfoKey">Relationship : </span>
            <span className="rightbarInfoValue">
              {user.relationship ? user.relationship : "-"}
            </span>
          </div>
        </div>
        <h3 className="rightbarTitle">User Friends</h3>
        <div className="rightbarFollowings">
          {friends.map((p) => {
            return (
              <Link
                to={"/profile/" + p.username}
                style={{ textDecoration: "none" }}
              >
                <div key={p.id} className="rightbarFollowing">
                  <img
                    src={
                      p.profilePicture
                        ? PF + "/" + p.profilePicture
                        : PF + "/users/noAvatar.png"
                    }
                    alt=""
                    className="rightbarFollowingImg"
                  />
                  <span className="rightbarFollowingName">{p.username}</span>
                </div>
              </Link>
            );
          })}
        </div>
      </>
    );
  };

  return (
    <div className="rightbar" style={{ flex: "3" }}>
      <div className="rightbarWrapper">
        {user ? <ProfileRightbar /> : <HomeRightbar />}
      </div>
    </div>
  );
}

export default Rightbar;
